import dateFormat from 'dateformat';
import {
  mapKeys,
  mapValues,
  isPlainObject,
  isArray,
  camelCase,
} from 'lodash-es';

export const formatPhone = (value = '', { forHtml } = {}) => {
  const space = forHtml ? '&nbsp' : ' ';
  function standardize(value) {
    return (value || '').replace(/[\D\s]/g, '').substring(0, 10);
  }
  const formatted = standardize(String(value)).replace(
    /^(\d{0,3})(\d{0,3})(\d{0,4})$/,
    (match, p1, p2, p3) => `(${p1})${space}${p2}-${p3}`
  );
  return formatted;
};

export const ssnMaskFormat = (value = '') => {
  function standardize(value) {
    return (value || '').replace(/[\D\s]/g, '').substring(0, 10);
  }
  const formatted = standardize(value).replace(
    /^(\d{0,3})(\d{0,2})(\d{0,4})$/,
    (match, p1, p2, p3) => `XXX-XX-${p3}`
  );
  return formatted;
};

const fromFormats = {
  'yyyy-mm-dd': (dateString = '') => {
    // console.log('yyyy-mm-dd', dateString);
    if (dateString.length < 10) {
      return new Date('invalid');
    }
    const [year, month, day] = (dateString || '').split('-');
    const ret = new Date(Number(year), Number(month) - 1, Number(day));
    // console.log('yyyy-mm-dd', ret);
    return ret;
  },
  'mm-dd-yyyy': (dateString = '') => {
    // console.log('yyyy-mm-dd', dateString);
    if (dateString.length < 10) {
      return new Date('invalid');
    }
    const [month, day, year] = (dateString || '').split('-');
    const ret = new Date(Number(year), Number(month) - 1, Number(day));
    // console.log('yyyy-mm-dd', ret);
    return ret;
  },
  'mm/dd/yyyy': (dateString = '') => {
    // console.log('mm/dd/yyyy', dateString);
    if (dateString.length < 10) {
      return new Date('invalid');
    }
    const [month, day, year] = (dateString || '').split('/');
    const ret = new Date(Number(year), Number(month) - 1, Number(day));
    // console.log('mm/dd/yyyy', ret);
    return ret;
  },
};

export const formatDateString = (
  dateString,
  toFormat,
  fromFormat = 'yyyy-mm-dd'
) => {
  // console.log('Formatting', dateString);
  const date = fromFormats[fromFormat](dateString);
  if (isNaN(date.getTime())) {
    // console.log('Invalid', dateString);
    return dateString; // return original string if invalid.
  }
  const format = dateFormat(date, toFormat);
  // console.log('Formatted', format);
  return format;
};

export const formatPrice = price => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...(price > 10 ? { maximumSignificantDigits: price < 100 ? 2 : 3 } : {}),
    minimumFractionDigits: price < 10 ? 2 : 0,
  });
  return formatter.format(price);
};

const mapKeysDeep = (obj, cb) =>
  mapValues(mapKeys(obj, cb), val =>
    isPlainObject(val)
      ? mapKeysDeep(val, cb)
      : isArray(val)
      ? val.map(a => (isPlainObject(a) ? mapKeysDeep(a, cb) : a))
      : val
  );

export const deepCamelCaseKeys = obj => {
  return mapKeysDeep(obj, (_, key) => camelCase(key));
};
